import { type UpdateHookResponse, mutationUpdate } from '../../hooks'
import { useTantalimMutation } from '../../mutation'
import { useGameCache } from '../cache'
import {
  type DecoratedGameParticipant,
  type GameParticipantUpdateInput,
  type GameParticipantUpdateSuccess,
  Logger,
  toResponseError,
} from '@terros/common'

const logger = new Logger('useUpdateGameParticipant')
// logger.level = 'verbose'

export function useUpdateGameParticipant(): UpdateHookResponse<
  GameParticipantUpdateInput['participant'],
  DecoratedGameParticipant
> {
  const cache = useGameCache()
  const mutation = useTantalimMutation<GameParticipantUpdateInput, GameParticipantUpdateSuccess>({
    url: '/game/participant/update',
  })

  async function update(participant: GameParticipantUpdateInput['participant']): Promise<DecoratedGameParticipant> {
    try {
      const { participant: updated } = await mutation.mutateAsync({ participant })
      logger.verbose('game participant updated', updated)
      cache.updateParticipant(participant.gameId, updated)
      return updated
    } catch (error) {
      logger.error('error updating game participant', error)
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
